import React from 'react'
import styled from 'styled-components'
import { ContainerFooter } from './styled'

const Footer = () => {
    return (
        <ContainerFooter className="container has-text-centered">
            <Content>
                Built by Shadrack Mwangi (<Inset>@shaddyshad</Inset>)
            </Content>
            <div className="is-flex is-justify-content-center">
                <Icon className="icon is-medium" href="https://github.com/shaddyshad" name="Github link">
                    <i className="fab fa-github"></i>
                </Icon>
                <Icon className="icon is-medium" href="https://www.linkedin.com/in/shadrack-mwangi-55a8b1b2/" name="Linkedin link">
                    <i className="fab fa-linkedin"></i>
                </Icon>
            </div>
        </ContainerFooter>
    )
}

const Content = styled.p `
    color: #a7a2a2;
`

const Icon = styled.a `
    color: #da6c36;
    width: 48px;
    height: 48px;
`

const Inset = styled.span `
    font-size: 1em;
    color: #da6c36;
`

export default Footer;